import { connect } from 'react-redux'
import { HeaderModalAlertComponent } from './HeaderModalAlertComponent'
import type { Dispatch } from 'redux'
import { push } from 'connected-react-router'

const mapDispatchToProps = (d: Dispatch<any>) => ({
    navigate: (to: string, state?: any) =>
        d(
            push({
                pathname: to,
                state
            })
        )
})

const HeaderModalAlert = connect(
    null,
    mapDispatchToProps
)(HeaderModalAlertComponent)

export { HeaderModalAlert }
